import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Tooltip,
  Box,
  useTheme as useMuiTheme,
  alpha
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Folder as FolderIcon,
  Message as MessageIcon,
} from '@mui/icons-material';

const drawerWidth = 64;

const menuItems = [
  { text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard' },
  { text: 'Projects', icon: <FolderIcon />, path: '/projects' },
//* { text: 'Tasks', icon: <AssignmentIcon />, path: '/tasks' }, *//
  { text: 'Messaging', path: '/team', icon: <MessageIcon /> },
//* { text: 'Calendar', path: '/calendar', icon: <CalendarIcon /> }, *//
];

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const muiTheme = useMuiTheme();

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          backgroundColor: muiTheme.palette.mode === 'dark'
            ? alpha('#0a0a0a', 0.95)
            : '#fff',
          backdropFilter: 'blur(10px)',
          borderRight: `1px solid ${alpha(muiTheme.palette.divider, muiTheme.palette.mode === 'dark' ? 0.25 : 0.1)}`,
          boxShadow: muiTheme.palette.mode === 'dark'
            ? `8px 0 32px ${alpha(muiTheme.palette.common.black, 0.7)}, 1px 0 0 ${alpha(muiTheme.palette.common.white, 0.05)}`
            : '4px 0 12px rgba(0,0,0,0.08)',
        },
      }}
    >
      <Box sx={{ 
        py: 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderBottom: `1px solid ${alpha(muiTheme.palette.divider, 0.1)}`
      }}>
        <Box
          sx={{
            width: 36,
            height: 36,
            minWidth: 36,
            minHeight: 36,
            borderRadius: '50%',
            background: `linear-gradient(135deg, ${muiTheme.palette.primary.main}, ${muiTheme.palette.primary.dark})`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: `0 4px 12px ${alpha(muiTheme.palette.primary.main, 0.3)}`,
            fontWeight: 700,
            fontSize: '1.25rem',
            color: 'white',
            flexShrink: 0
          }}
        >
          L
        </Box>
      </Box>
      <List sx={{ px: 1, py: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {menuItems.map((item) => {
          const isSelected = location.pathname === item.path;
          return (
            <Tooltip title={item.text} placement="right" key={item.text}>
              <ListItem disablePadding>
                <ListItemButton
                  onClick={() => navigate(item.path)}
                  selected={isSelected}
                  sx={{
                    borderRadius: 2,
                    mb: 0.5,
                    py: 1.25,
                    px: 1.25,
                    width: 44,
                    minWidth: 44,
                    justifyContent: 'center',
                    transition: 'all 0.2s ease',
                    '&.Mui-selected': {
                      backgroundColor: alpha(muiTheme.palette.primary.main, 0.12),
                      '& .MuiListItemIcon-root': {
                        color: muiTheme.palette.primary.main
                      }
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: alpha(muiTheme.palette.primary.main, 0.18)
                    },
                    '&:hover': {
                      backgroundColor: muiTheme.palette.mode === 'dark' 
                        ? alpha(muiTheme.palette.common.white, 0.05)
                        : alpha(muiTheme.palette.common.black, 0.03)
                    }
                  }}
                >
                  <ListItemIcon sx={{ 
                    minWidth: 'auto',
                    transition: 'all 0.2s ease',
                    color: isSelected ? muiTheme.palette.primary.main : 'inherit',
                    '& .MuiSvgIcon-root': {
                      fontSize: 20
                    }
                  }}>
                    {item.icon}
                  </ListItemIcon>
                </ListItemButton>
              </ListItem>
            </Tooltip>
          );
        })}
      </List>
    </Drawer>
  );
}

export default Sidebar;
